import type { Ref } from 'vue'
import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { FetchPrivateSuppliersSuccessResponse } from '@/modules/Profile/types/api/response/privateSupplier'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'private-supplier'
const ENDPOINT = '/tripmentor/Supplier'

export function fetchPrivateSuppliers(
  type: string,
  page: number,
  size: number
) {
  return axiosInstance
    .get<FetchPrivateSuppliersSuccessResponse>(ENDPOINT, {
      params: { type, page, size },
    })
    .then((response) => response.data)
}

export function useFetchPrivateSupplierQuery(
  page: Ref<number>,
  size: Ref<number>,
  type: Ref<string>,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchPrivateSuppliers>>>
) {
  return useQuery({
    queryKey: [QUERY_KEY, type, page, size],
    queryFn: () => fetchPrivateSuppliers(type.value, page.value, size.value),
    ...options,
  })
}
